import type { FC } from 'react';

import Icon80 from '../../assets/static/icon80.png';
import Exchange from './assets/exchange.png';
import { Header, Icons } from './styles';

export interface OauthHeaderProps {
    icon: string;
    title: string;
}

const OauthHeader: FC<OauthHeaderProps> = ({ icon, title }) => (
    <>
        <Icons>
            <img src={icon} alt={title} width="80" height="80" />
            <img src={Exchange} alt="" />
            <img src={Icon80} alt="Lokalise" width="80" height="80" />
        </Icons>
        <Header>
            <strong>{title}</strong> wants to access <strong>Lokalise</strong>
        </Header>
    </>
);

export default OauthHeader;
